module.exports = __webpack_public_path__ + "static/media/challenge-media.9aa6ad0a.svg";